import './ActionButton.css';

export default function ActionButton({
  label,
  onClick,
  type = 'button',
  className = '',
}) {
  if (!label) return null;

  const classes = ['ActionButton', className].filter(Boolean).join(' ');

  return (
    <button type={type} className={classes} onClick={onClick}>
      {label}
    </button>
  );
}
